module.exports = "<div class=\"\" ng-transclude></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpTimelineContextualMenu/adpTimelineContextualMenu.html
// module id = 663
// module chunks = 0